module.exports = __webpack_public_path__ + "img/bot_2.ce836e50.png";